/**
 * External dependencies
 */
import Immerable from '@naruto/naruto-reducers/src/types/GeneralImmer';

/**
 * Internal dependencies
 */
import { ContactInfo } from './types';

class Contact extends Immerable {
  public contactInfo: ContactInfo;

  public constructor() {
    super();
    this.contactInfo = {
      contact: {
        ctime: '',
        mtime: ''
      }
    };
  }

  public initialize(): void {
    this.contactInfo = {
      contact: {
        ctime: '',
        mtime: ''
      }
    };
  }

  public updateContactInfo(newContact: ContactInfo): void {
    this.contactInfo = newContact;
  }
}

export default Contact;
